import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { ModalController, Platform } from '@ionic/angular';
import { UserApiService } from 'src/app/lib/services/api/modules/user.api';
import { UtilService } from 'src/app/lib/services/util.service';


@Component({
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewsletterComponent implements OnInit{

  public cordova: boolean = false;
  constructor(
    private modalController: ModalController,
    private userApiService: UserApiService,
    public utilsService: UtilService
  ) {}
  
  ngOnInit(): void {
    if (this.utilsService.isCapacitor() && !this.utilsService.isTablet()) this.cordova = true;
  }

  dismiss() {
    this.modalController.dismiss();
  }

  async subscribe(){
    await this.userApiService.subscribeNewsletter(true);
    this.dismiss();
  }
}
